<!-- <div style="padding: 45px; text-align: center">
  <h3>{{ message }}</h3>
</div> -->
<div class="notification-container">
  <div class="notification-card">
    <div class="icon">⚠️Important Notice</div>
    <p class="message">
      {{ message }}
    </p>

    <button class="close-btn" (click)="closeDialog()">
      Close
    </button>
  </div>
</div>